import React from 'react'
import PropTypes from 'prop-types'
import {Row, Col} from 'reactstrap'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

const ProjectUserListItem = ({first_name, last_name, total_minutes_worked, expenditure, canViewFinances}) => {

    return (
        <Row className="p-2 border-bottom align-items-center">
            <Col>
                {first_name} {last_name}
            </Col>
            <Col sm="2" className="d-flex justify-content-end">
                <span style={{fontSize: '1.5rem'}}>{total_minutes_worked ? (total_minutes_worked/60).toFixed(2) : total_minutes_worked}hrs</span>
            </Col>
            {canViewFinances && <Col sm="2" className="d-flex justify-content-end">
                <span style={{fontSize: '1.5rem'}}>{format(expenditure)}</span>
            </Col>}
        </Row>
    )

}

ProjectUserListItem.propTypes = {
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    total_minutes_worked: PropTypes.number.isRequired,
    canViewFinances: PropTypes.bool.isRequired
}

export default ProjectUserListItem